<template>
  <div class="container">

    <el-tabs v-model="activeName">
      <el-tab-pane label="未读" name="BackFeedbackNoReadList">
        <BackFeedbackNoReadList :tableData = "notReadData" @refreshFeedbackList="refreshFeedbackList"></BackFeedbackNoReadList>
      </el-tab-pane>
      <el-tab-pane label="已读" name="BackFeedbackReadList">
        <BackFeedbackReadList :tableData = "readData" @refreshFeedbackList="refreshFeedbackList"></BackFeedbackReadList>
      </el-tab-pane>
      <!--        <el-tab-pane label="已删除" name="FeedbackDeleteList">-->
      <!--          <FeedbackDeleteList :tableData = "deleteData"></FeedbackDeleteList>-->
      <!--        </el-tab-pane>-->
    </el-tabs>

  </div>
</template>

<script>
import {getFeedBackList} from '../../../../../request/api'
import Utils from '../../../../../js/Utils'
import BackFeedbackReadList from './BackFeedbackReadList'
import BackFeedbackNoReadList from './BackFeedbackNoReadList'

export default {
  name: 'BackFeedbackManage',
  components: {BackFeedbackReadList, BackFeedbackNoReadList},
  data () {
    return {
      activeName: 'BackFeedbackNoReadList',
      notReadData: [],
      readData: []
    }
  },
  created () {
    this.getData()
  },
  methods: {

    getData () {
      getFeedBackList().then(res => {
        console.log(res)

        if (res.code === '90') {
          this.readData = []
          this.notReadData = []
          this.deleteData = []
          for (var i = 0; i < res.data.length; i++) {
            var feedbackItem = res.data[i]
            if (feedbackItem.is_read === true) {
              this.readData.push(feedbackItem)
            } else {
              this.notReadData.push(feedbackItem)
            }
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        // error

        console.log(error)
      })
    },
    refreshFeedbackList (data) {
      console.log(data)
      this.getData()
    },
    changeTimeDate (date) {
      var timeStr = Utils.formatDate(date.time)
      return timeStr
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/back/feedback/BackFeedbackManage.vue